import React from "react";
import MaskingTape from "./MaskingTape";
import { useReveal } from "../../hooks/useReveal";
import { Quote } from "lucide-react";

const PolaroidCard = ({
    quote,
    author,
    tape = "yellow",
    rotation = "-rotate-1",
    delay = 0,
    testId,
    accent = "#E05236",
}) => {
    const [ref, visible] = useReveal();

    return (
        <article
            ref={ref}
            data-testid={testId}
            className={`reveal-up ${visible ? "is-visible" : ""} relative bg-white p-7 pb-12 scrap-shadow border border-neutral-200/80 ${rotation} hover:rotate-0 hover:scale-[1.025] hover:z-20 transition-transform duration-500 ease-out`}
            style={{ transitionDelay: `${delay}ms` }}
        >
            <MaskingTape
                color={tape}
                className="-top-3 left-1/2 -translate-x-1/2 w-32 h-7"
            />
            <Quote
                className="absolute top-4 left-4 text-marker-red/20"
                size={36}
                strokeWidth={1.5}
                aria-hidden="true"
            />
            <p className="font-editorial italic text-[1.35rem] sm:text-[1.5rem] leading-snug text-ink mt-4 mb-6 relative z-10">
                &ldquo;{quote}&rdquo;
            </p>
            <div className="dashed-divider mb-3" />
            <p
                className="font-handwriting text-xl text-marker-red"
                style={{ color: accent }}
            >
                — {author}
            </p>
        </article>
    );
};

export default PolaroidCard;
